<template>
  <div class="jd" v-if="job">
    <Loader v-if="isSubmitting" />
    <div class="jd-container pt-1" :class="backgroundClass" v-else>
      <!-- Top: Back button and Radio button on same line (flex end) -->
      <div class="jd-top-header d-flex justify-content-end align-items-center mt-2">
        <p class="back-button mb-0 mr-3" @click="returnToJd">く 一覧に戻る</p>
        <div class="radio-container d-flex align-items-center">
          <input
            type="radio"
            name="jd_select"
            class="form-check-input match-checkbox"
            :checked="isMatchedJd"
            :disabled="isSubmitting"
            @click="handleRadioClick(job, isMatchedJd, $event)"
            style="width: 20px;height:20px"
          />
          <p class="mb-0 ml-2 mt-1">選択</p>
        </div>
      </div>

      <!-- Below: "この求人を選択する" text -->
      <div class="jd-selection-label mr-4 ml-4">
        <p @click="openJdLink()" class="jd-link">
          自社採用ホームページへの遷移はこちら
        </p>
      </div>

      <!-- Below: Scouted button -->
      <div class="jd-scouted-button mr-4 ml-4" v-if="isScoutedJd">
        <button 
          class="scouted-btn" 
          :class="{ 'scouted-btn-expired': isScoutedExpired }"
          disabled
        >
          {{ scoutedButtonText }}
        </button>
      </div>

      <!-- Below: Date part -->
      <div class="jd-date-section mr-4 ml-4">
        <p class="jd-detail font-18 mb-0">
          <span class="jd-date ml-2">求人反映/更新日： {{ jobDate }}</span>
        </p>
      </div>

      <!-- Finally: Job title -->
      <div class="job-description">
        <div class="job-title mb-3">
          <h2>{{ job.job_title }}</h2>
        </div>
 
        <div v-html="job.job_description" class="message-body"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../../../../utils/Loader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
export default {
  data() {
    return {
      isSubmitting: false,
    };
  },
  props: ['applicantId'],
  components: { Loader },
  computed: {
    ...mapState({
      profile: ({ applicant }) => applicant.profile,
      job: ({ applicant }) => applicant.individualJD,
      applicantJD: ({ applicant }) => applicant.applicantJD,
      scoutedJD: ({ applicant }) => applicant.scoutedJD,
      userBasedMatching: ({ applicant }) => applicant.userBasedMatching,
    }),
    jobDate() {
      let date = this.job.updated_at || this.job.created_at;
      return moment(date).format('YYYY/MM/DD');
    },
    isScoutedJd() {
      const { scouted_jobs } = this.profile;
      return scouted_jobs.some((jobDetails) => jobDetails.job === this.job._id);
    },
    scoutedJobStatus() {
      if (!this.profile || !this.profile.scouted_jobs) return null;
      const scoutedJob = this.profile.scouted_jobs.find(
        (jobDetails) => jobDetails.job === this.job._id
      );
      return scoutedJob ? scoutedJob.status : null;
    },
    isScoutedExpired() {
      return this.scoutedJobStatus === 'expired';
    },
    scoutedButtonText() {
      if (this.isScoutedExpired) {
        return 'スカウト希望期間終了';
      }
      return 'スカウト希望中';
    },
    isMatchedJd() {
      return (
        this.job && this.job._id === (this.applicantJD && this.applicantJD._id)
      );
    },
    backgroundClass() {
      if (this.isMatchedJd) {
        return 'match-color';
      } else {
        return '';
      }
    },
    jdButtonClass() {
      if (this.isMatchedJd) {
        return 'select-btn';
      } else {
        return 'deselect-btn';
      }
    },
    jdButtonText() {
      if (this.isMatchedJd) {
        return 'JD選択を解除する';
      } else {
        return 'このJDを選択する';
      }
    },
  },
  methods: {
    ...mapMutations({
      setProfileView: 'setProfileView',
    }),
    ...mapActions({
      toggleJobseekerSelection: 'toggleJobseekerSelection',
    }),
    openJdLink() {
      window.open(this.job.jd_url, '_blank');
    },
    returnToJd() {
      this.setProfileView({
        view: 'jdList',
        applicantJD: this.applicantJD,
        userBasedMatching: this.userBasedMatching,
      });
    },
    async toggleJDMatch(jd) {
      this.isSubmitting = true;
      try {
        const data = {
          eligibility: true,
          jobseekerId: this.applicantId,
          // matching_score: 0,
        };
        data.timestamp = moment().format('YYYY-MM-DD HH:mm');
        await this.toggleJobseekerSelection({
          jd,
          unselect: this.isMatchedJd,
          id: this.applicantId,
          data,
        });
        this.isSubmitting = false;
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
        this.parseErrorResponse(err.response);
      }
    },
    handleRadioClick(jd, currentState, event) {
      if (currentState) {
        event.target.checked = false;
        this.toggleJDMatch(jd);
      } else {
        this.toggleJDMatch(jd);
      }
    }
    // toggleJDMatch(jd) {
    //   this.$emit('matchJd', jd, this.isMatchedJd);
    // },
  },
};
</script>

<style scoped>
.jd {
  background-color: #EBEFF1;
}
.jd-date {
  font-size: 11px; 
  font-weight: 400;
}
.scouted-btn {
  min-width: 168px;
  height: 25px;
  font-weight: bold;
  text-align: center;
  font-size: 10px;
  padding: 5px 10px;
  border-radius: 20px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #14B8A6;
  color: #fff;
  border: 1px solid #14B8A6;
}

.scouted-btn-expired {
  background-color: #C4C4C4;
  color: #515C6B;
  border: 1px solid #C4C4C4;
}
.deselect-btn {
  background: #036d6c !important;
  color: #fff !important;
}

.select-btn {
  background: #fff !important;
  color: #036d6c !important;
}

.jd-link {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
  margin: 0px;
  padding: 0px;
}

.btn-back {
  background: #b3b3b3;
  padding: 5px;
  font-size: 14px;
  border-radius: 0px !important;
  border: 1px solid #000;
}

.btn-select {
  padding: 5px;
  font-size: 14px;
  border-radius: 0px !important;
  border: 1px solid #036d6c;
}

.font-18 {
  font-size: 18px;
}

.btn-back:hover,
.btn-select:hover {
  opacity: 0.8;
}


.match-color {
  background: #2f80ed33 !important;
}

.job-description {
  max-height: 65vh !important;
  overflow-y: scroll !important;
  padding: 5px 15px !important;
  color: #000000 !important;
}

.job-title {
  padding: 10px 5px 5px 5px;
  /* background-color: #fff; */
}

h2 {
  cursor: pointer;
  font-size: 18px;
}

.jd-top-header {
  padding: 2px;
  gap: 80px;
  margin-right: 20px;
}

.back-button {
  font-size: 14px;
  color: #3c3c3c;
  font-weight: normal;
  margin-right: 20px;
  cursor: pointer;
}

.jd-selection-label {
  margin-top: 5px;
}

.jd-scouted-button {
  margin-top: 5px;
}

.jd-date-section {
  margin-top: 5px;
}

.job-description  {
  font-size: 12px;
}
</style>
